import ServiceCategoryPage from "../components/ServiceCategoryPage";
import dogCareService from "../data/services/dogCareService";

function DogCare() {
  return <ServiceCategoryPage service={dogCareService} />;
}

export default DogCare;